import previousTestTableMock from "../mockDb/previousTestTableMock";
import { PREVIOUS_TESTS_URL } from "../../_redux/previousTests";

export default function mockPreviousTest(mock) {
  mock.onPost(PREVIOUS_TESTS_URL).reply((config) => {
    const request = JSON.parse(config.data);
    console.log("request", request);
    return [200, previousTestTableMock];
  });
}
